import React, { useState, useEffect } from 'react'
import BannerBg from '../assets/banner-bg.jpg';
import '../css/Admin/AdminDashboard.css';
import { useNavigate } from 'react-router-dom';
import ResponseMsg from '../general/ResponseMsg';
import Loading from '../general/Loading';
import Default from '../assets/default.jpg';


const AdminDashboard = ({ userData }) => {
  const [highDemandProduct, setHighDemandProduct] = useState([]);
  const [response, setResponse] = useState(null);
  const [offers, setOffers] = useState([]);
  const [item, setItem] = useState([]);
  const [party, setParty] = useState([]);
  const [payData, setPayData] = useState([]);
  const [dueData, setDueData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showEditOffer, setShowEditOffer] = useState(false);
  const [showDeleteOffer, setShowDeleteOffer] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState('');
  const [selectedDue, setSelectedDue] = useState(false);
  const [showDue, setShowDue] = useState('');
  const [offerData, setOfferData] = useState({
    offerName: '',
    offerTagline: '',
    offerImage: null,
    description: ''
});


  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await fetch('https://api.kcmstore.in/dist/get-offers');
        if (response.ok) {
          const data = await response.json();
          setOffers(data);
        } else {
          console.error('Failed to fetch offers');
        }
      } catch (error) {
        console.error('Error fetching offers:', error);
      }
    };

    const fetchProducts = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.kcmstore.in/dist/get-product');
        if (response.ok) {
          const data = await response.json();
          setItem(data);
          setLoading(false);
        } else {
          setLoading(false);
          console.error('Failed to fetch users');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching data:', error);
      }
    };

    const fetchParty = async () => {
      try {
        const response = await fetch('https://api.kcmstore.in/dist/get-party');
        if (response.ok) {
          const data = await response.json();
          const filteredParty = data.filter(user => user.id !== userData.id);
          setParty(filteredParty);
        } else {
          console.error('Failed to fetch users');
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    const fetchOrders = async () => {
      setLoading(true);

      try {
        const response = await fetch(`https://api.kcmstore.in/dist/get-orders`);
        setLoading(false);
        if (response.ok) {
          const data = await response.json();
          const mostDemanded = getMostInDemandProducts(data);
          console.log(mostDemanded);
          setHighDemandProduct(mostDemanded);
         } else {
          setLoading(false);
          console.error('Failed to fetch products');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching products:', error);
      }
    };

    fetchOffers();
    fetchProducts();
    fetchParty();
    fetchOrders();
  }, []);


  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const response = await fetch(`https://api.kcmstore.in/dist/get-payment-history`);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          setPayData(sortedProducts);
          const filteredPayments = sortedProducts.filter(payment => payment.total_amount != payment.amount_received);
          setDueData(filteredPayments);
        } else {
          console.error('Failed to fetch products');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchPayments();
  }, []);


  const calculateTotalSales = () => {
    const total = payData.reduce((acc, payment) => {
      const amount = parseFloat(payment.total_amount);
      if (!isNaN(amount)) {
        return acc + amount;
      } else {
        console.error('Invalid total_amount:', payment.total_amount);
        return acc;
      }
    }, 0);
  
    return parseFloat(total.toFixed(2));
  };
  
  const getMostInDemandProducts = (orders) => {
    const productMap = new Map();
  
    orders.forEach(order => {
      const items = JSON.parse(order.order_items);
  
      items.forEach(item => {
        const productId = item.product_id;
  
        if (productMap.has(productId)) {
          const existing = productMap.get(productId);
          existing.quantity += item.quantity;
          existing.count += 1;
          productMap.set(productId, existing);
        } else {
          productMap.set(productId, {
            product_id: productId,
            product_name: item.product_name,
            image: item.image,
            quantity: item.quantity,
            count: 1
          });
        }
      });
    });
  
    // Convert map to array and sort by total quantity or order count
    const sortedProducts = Array.from(productMap.values())
      .sort((a, b) => b.quantity - a.quantity);
  
    return sortedProducts;
  };
  

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };


  const handleEditOffer = (offer) => {
    setShowEditOffer(true);
    setSelectedOffer(offer);
    setOfferData({
        offerName: offer.offer_name,
        offerTagline: offer.offer_tagline,
        offerImage: null,
        description: offer.description
    })
}


const handleOfferChange = (e) => {
  const { id, value, type, files } = e.target;
  if (type === 'file') {
      setOfferData({
          ...offerData,
          [id]: files[0]
      });
  } else {
      setOfferData({
          ...offerData,
          [id]: value
      });
  }
};


const updateOfferSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
      const formDataToSend = new FormData();
      Object.keys(offerData).forEach((key) => {
          formDataToSend.append(key, offerData[key]);
      });

      const response = await fetch(`https://api.kcmstore.in/dist/update-offer/${selectedOffer.id}`, {
          method: 'PUT',
          body: formDataToSend
      });

      setLoading(false);
      
      if (response.ok) {
          const updatedProduct = await response.json();
          setResponse('Offer updated successfully!');
          setTimeout(() => {
              setResponse('');
              setShowEditOffer(false);
              window.location.reload();
          }, 1500);
      } else {
        setLoading(false);
              setResponse('Unable to update offer.');
          setTimeout(() => {
              setResponse('');
          }, 2000);
      }
  } catch (error) {
    setLoading(false);
          console.error('Error updating offer:', error);
  }
}

const handleShowDue = (paymentData) => {
  setSelectedDue(paymentData);
  setShowDue(true);
}

const handleDeleteOfferDialog = (offer) => {
  setShowDeleteOffer(true);
  setSelectedOffer(offer);
}


const handleDeleteOffer = async (offerId) => {
  setLoading(true);

  try {
      const response = await fetch(`https://api.kcmstore.in/dist/delete-offer/${offerId}`, {
          method: 'DELETE',
      });

      setLoading(false);

      if (response.ok) {
          setResponse('Offer removed successfully!');
          setTimeout(() => {
              setResponse('');
              window.location.reload();
          }, 1500);
          setShowDeleteOffer(false);
      } else {
          setLoading(false);
          setResponse('Unable to Delete Offer.');
          setTimeout(() => {
              setResponse('');
          }, 2000);
          setShowDeleteOffer(false);
      }
  } catch (error) {
      setLoading(false);
      console.error('Error deleting Offer:', error);
  }
};

const getGreeting = () => {
  const currentHour = new Date().getHours();

  if (currentHour < 12) return 'Good Morning 🌻';
  else if (currentHour < 16) return 'Good Afternoon 🌞';
  else if (currentHour < 20) return 'Good Evening ⭐';
  else return 'Good Night 😴';
};


  return (
    <>
      <section className='px-md-4 my-4'>
        <div className='profile-area-inner px-3 py-md-3'>
          <p className='profile-heading fs-5 my-0'>{getGreeting()} Admin</p>
          {/* <hr className='profile-hr' /> */}


          <div className='row'>


            <div className='col-lg-9 col-12 my-2'>

              <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
    <div className="carousel-indicators">
        {offers.length > 0 &&
            offers.map((offer, index) => (
                <button
                    key={index}
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide-to={index}
                    className={index === 0 ? 'active' : ''}
                    aria-label={`Slide ${index + 1}`}
                ></button>
            ))
        }
    </div>

    <div className="carousel-inner">
        {offers.length > 0 ? (
            offers.map((offer, index) => {
                const offerUrl = `https://api.kcmstore.in/uploads/${offer['image']}`;
                return (
                  <>
                    <div
                        key={index}
                        className={`carousel-item align-content-center ${index === 0 ? 'active' : ''} banner-bg`}
                        style={{ backgroundImage: `url(${offerUrl || BannerBg})` }}
                    >
                        <div className="container py-5">
                            <p className="fs-5 fw-semibold">{offer.offer_tagline}</p>
                            <p className="banner-heading col-lg-6 col-md-8">{offer.offer_name}</p>
                            <p className="col-lg-5 col-md-8 fw-semibold">{offer.description}</p>
                            <button className='login-btn px-2 py-1 bg-white text-black text-capitalize' onClick={() => handleEditOffer(offer)}>Edit Offer</button>&nbsp;&nbsp;
                            <button className='login-btn px-2 py-1 bg-white text-black text-capitalize' onClick={() => handleDeleteOfferDialog(offer)}>Remove ❌</button>
                        </div>
                    </div>
                    </>
                );
            })
        ) : (
            <div className="carousel-item active banner-bg" style={{ backgroundImage: `url(${BannerBg})` }}>
                <div className="container py-5">
                    <p className="fs-5 fw-semibold">Get Medicines at your Doorstep</p>
                    <p className="banner-heading col-lg-6 col-md-8">KCM - Your Online Medical Buddy</p>
                    <p className="col-lg-5 col-md-8 fw-semibold">
                        We deliver a wide range of medicines directly to your doorstep, ensuring convenience and reliability. Your health is our top priority!
                    </p>
                </div>
            </div>
        )}
    </div>
</div>

            </div>
            {/* left ends */}

            <div className='col-lg-3 col-md-4 col-sm-6 col-12 my-2'>
              <div className='admin-card'>
                <i class="fa-solid fa-chart-simple admin-icon"></i>
                <p className='admin-heading mb-0 mt-3'>Total Sales</p>
                <p className='admin-text'>{calculateTotalSales() || '0'}</p>
                <button className='admin-btn' onClick={() => navigate('/payment-history')}>View Sales</button>
              </div>
            </div>


            <div className='col-lg-3 col-md-4 col-sm-6 col-12 my-2'>
              <div className='admin-card'>
                <i class="fa-solid fa-cubes-stacked admin-icon animate__animated animate__fadeInDown animate__infinite"></i>
                <p className='admin-heading mb-0 mt-3'>Total Products</p>
                <p className='admin-text'>{item.length || '0'}</p>
                <button className='admin-btn' onClick={() => navigate('/inventory')}>Inventory Items</button>
              </div>
            </div>

            <div className='col-lg-3 col-md-4 col-sm-6 col-12 my-2'>
              <div className='admin-card'>
                <i class="fa-solid fa-network-wired admin-icon animate__animated animate__flipInY animate__infinite"></i>
                <p className='admin-heading mb-0 mt-3'>Parties Added</p>
                <p className='admin-text'>{party.length || '0'}</p>
                <button className='admin-btn' onClick={() => navigate('/view-party')}>View Parties</button>
              </div>
            </div>

            <div className='col-lg-6 col-12 my-2'>
              <div className='due-area-outer px-md-3 py-3'>

                <div className='d-flex justify-content-between'>
                  <p className='profile-subheading my-2'>Recent Dues</p>
                  <button className='admin-btn' onClick={() => navigate('/manage-dues')}>All Dues</button>
                </div>
                {/* flex ends */}
                <hr className='profile-hr' />


{payData.length > 0 ? (
  payData.slice(0,3).map((paymentData) => (
<div className='due-area my-2 cursor-pointer' onClick={() => handleShowDue(paymentData)}>
  <div className='d-flex justify-content-between'>
  <span className='fw-semibold'>{paymentData.customer_name}</span>
  <span className='due-tag'>Dues</span></div>
<div className='mt-2 d-md-flex justify-content-between'>Order Date: {formatDate(paymentData.order_date)}<br />
<span className='fw-semibold'>Amount Payable: ₹{paymentData.total_amount}<br/><span className='text-danger'>Due Amount: ₹{paymentData.due_amount}</span></span></div>
  </div>
  ))
): (
  <div className='due-area'>
  <p className='my-3 fw-semibold'>No Dues Yet.</p></div>
)}

              </div>
            </div>


          </div>
          {/* row ends */}

        </div>
      </section>


      <section className='my-4'>
  <div className='px-4'>
    <p className='profile-heading fs-5'>Most in-demand products</p>
    <hr className='profile-hr' />

    <div className='row'>
      {highDemandProduct.slice(0, 12).map((product, index) => (
        <div className='col-lg-4 col-md-6 col-12 my-2' key={index}>
          <div className='due-area d-flex'>
            <img
src={product.image
  ? `https://api.kcmstore.in/uploads/${product.image.split(',')[0]}`
  : Default}              className='col-md-3 col-sm-4 col-4'
              alt={product.product_name}
            />
            
            <div className='align-content-center ms-3'>
              <h6 className='fw-semibold'>{product.product_name}</h6>
              <p className='due-tag'>Total Ordered: {product.quantity}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


      {showEditOffer && (
                <>
                    <section className='detail-dialog px-2'>
                        <div className='detail-dialog-inner col-lg-5 col-md-8 mx-auto px-3 py-4 rounded-4'>

                        <p className='profile-subheading'>Edit This Offer</p>

                            <form className="g-3 bg-white text-start mt-4" onSubmit={updateOfferSubmit}>
                                {/* Product Name */}
                                <div className="col-12 my-2">
                                    <label htmlFor="productName" className="profile-label fw-semibold">Offer Name</label>
                                    <input
                                        type="text"
                                        className="profile-input"
                                        id="offerName"
                                        value={offerData.offerName}
                                        onChange={handleOfferChange}
                                    />
                                </div>

                                {/* Tagline */}
                                <div className="col-12 my-2">
                                    <label htmlFor="productTagline" className="profile-label fw-semibold">Offer Tagline</label>
                                    <input
                                        type="text"
                                        className="profile-input"
                                        id="offerTagline"
                                        value={offerData.offerTagline}
                                        onChange={handleOfferChange}
                                    />
                                </div>

                                {/* Image Upload */}
                                <div className="col-12 my-2">
                                    <label htmlFor="image" className="profile-label fw-semibold">Upload Image</label>
                                    <input
                                        type="file"
                                        className="profile-input bg-white"
                                        id="offerImage"
                                        onChange={handleOfferChange}
                                    />
                                </div>

                                {/* description */}
                                <div className="col-12 my-2">
                                    <label htmlFor="Description" className="profile-label fw-semibold">Description</label>
                                    <textarea
                                        type="text"
                                        className="profile-input"
                                        id="description"
                                        style={{ height: '6em' }}
                                        value={offerData.description}
                                        onChange={handleOfferChange}></textarea>
                                </div>

                                {/* Submit Button */}
                                <div className="col-12 text-end mt-3">
                                    <button className='login-btn px-3 py-1 bg-danger' onClick={() => setShowEditOffer(false)}>Cancel</button>&nbsp;&nbsp;
                                    <button className='login-btn px-3 py-1'>Update Offer</button>
                                </div>
                            </form>


                        </div>
                    </section>
                </>
            )}


{showDue && (
  <>

<section className='detail-dialog px-2'>
                        <div className='detail-dialog-inner col-lg-5 col-md-8 mx-auto px-3 py-4 rounded-4'>

                        <p className='profile-subheading'>Due Details</p>

                        <div className='due-area'>
                          <p className='fw-semibold'>Party Name: {selectedDue.customer_name}</p>
                          <p>Invoice No: {selectedDue.id}<br />Order Id: {selectedDue.order_id}<br />Order Date: {formatDate(selectedDue.order_date)}<br />
                          Payment Mode: {selectedDue.payment_mode}<br /><br />Total Amount Payable: ₹{selectedDue.due_amount}<br /><br />
                          <span className='text-success fw-semibold'>Amount Paid: ₹{selectedDue.amount_received}</span><br />
                          <span className='text-danger fw-semibold'>Due Amount: ₹{selectedDue.total_amount}</span></p>
                        </div>

                        <button className='login-btn px-3 py-1 mt-3' onClick={() => setShowDue(false)}>Close</button>&nbsp;&nbsp;

</div>
</section>
  </>
)}

{showDeleteOffer && (
                <section className='detail-dialog animate__animated animate__zoomIn' onClick={() => setShowDeleteOffer(false)}>
                    <div className='detail-dialog-inner col-lg-5 mx-auto px-lg-5 py-lg-5 px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>

                        <p className='profile-subheading'>Want to remove this offer?</p>

                        <div
                        className={`banner-bg my-3 align-content-center`}
                        style={{ backgroundImage: `url(https://api.kcmstore.in/uploads/${selectedOffer['image']})` }}
                        >
                        <div className="container text-start">
                            <p className="fs-5 fw-semibold">{selectedOffer.offer_tagline}</p>
                            <p className="banner-heading">{selectedOffer.offer_name}</p>
                            <p className="fw-semibold">{selectedOffer.description}</p>
                        </div>
                    </div>

                        <button className='login-btn px-3 py-1' onClick={() => handleDeleteOffer(selectedOffer.id)}>Yes</button>&nbsp;&nbsp;
                        <button className='login-btn px-3 py-1 bg-danger' onClick={() => setShowDeleteOffer(false)}>No</button>

                    </div>
                </section>
            )}

{loading && <Loading setLoading={setLoading} />}

{response && <ResponseMsg message={response} />}

    </>
  )
}

export default AdminDashboard
